import {useTitle as useTitleFn} from "@vueuse/core";

export function useTitle(newTitle) {
    return useTitleFn(newTitle, {
        titleTemplate: (value) => {
            if (!value) {
                return 'e-odsun.cz';
            } else {
                return `${value} | e-odsun.cz`;
            }
        }
    });
}
